module.exports = __webpack_public_path__ + "files/bfa08df0461b485bc600407ace8bd204.png";